// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"094b2b9f","205":"144f934b","232":"d47bb896","243":"2f71b7ef","333":"b227eb75","472":"e7f59163","796":"94595914","903":"fade9813","957":"5be04e6d"}[chunkId] + ".chunk.js";
};